module.exports = __webpack_public_path__ + "static/media/earnedInADay_25000_50000.e87080e7.png";